export const firebaseConfig = {
    apiKey: "AIzaSyDNvYuh9W0-i4TUgJrUcgxRONdeQTshXmk",
    authDomain: "rugbycore.firebaseapp.com",
    projectId: "rugbycore",
    storageBucket: "rugbycore.firebasestorage.app",
    messagingSenderId: "52547475673",
    appId: "1:52547475673:web:6f80960f559e00fb11c6c8",
    measurementId: "G-JFCTKRV3HY"
};
